import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { matchPath, Outlet, useLocation } from "react-router-dom";
import WatiWidget from "./../../components/WatiChat/WatiWidget";
import { useSelector } from "react-redux";

const isIOS = () => {
  return (
    typeof navigator !== "undefined" &&
    (/iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1))
  );
};

const Wrapper = ({ classNameWrapper }) => {
  const location = useLocation();
  const hideWidget = useSelector((state) => state.common.hideWidget);
  const [isIOSDevice, setIsIOSDevice] = useState(false);

  useEffect(() => {
    setIsIOSDevice(isIOS());
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const direction = location.state?.direction ?? 1;
  const dir = direction > 0 ? 1 : -1;

  const screensHideWatiChat = [
    "/quest/details/multiple/choice/:id",
    "/quest/details/completed",
  ];

  const shouldHideWatiChat = () => {
    return screensHideWatiChat?.some((pattern) => {
      if (pattern.includes(":")) {
        return matchPath({ path: pattern }, location.pathname);
      }
      return location.pathname === pattern;
    });
  };

  const hideWatiChat = shouldHideWatiChat();

  if (isIOSDevice) {
    return (
      <div className="relative w-full max-w-[430px] mx-auto h-screen overflow-hidden bg-black">
        {!hideWidget && !hideWatiChat && <WatiWidget />}
        <div className={`absolute inset-0 bg-white flex flex-col ${classNameWrapper}`}>{<Outlet />}</div>
      </div>
    );
  }

  return (
    <div className="relative w-full max-w-[430px] mx-auto h-screen overflow-hidden bg-black">
      {!hideWidget && !hideWatiChat && <WatiWidget />}
      <AnimatePresence initial={false} mode="sync" custom={dir}>
        <motion.div
          key={location.pathname}
          custom={dir}
          variants={{
            enter: (dir) => ({
              x: dir > 0 ? "100%" : "-100%",
              opacity: 1,
            }),
            center: {
              x: 0,
              opacity: 1,
              zIndex: 1,
            },
            exit: (dir) => ({
              x: dir > 0 ? "-10%" : "10%",
              opacity: 0.8,
              zIndex: 0,
            }),
          }}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            x: { type: "spring", stiffness: 360, damping: 36 },
            opacity: { duration: 0.1 },
          }}
          className={`absolute inset-0 bg-white flex flex-col ${classNameWrapper}`}
        >
          <Outlet />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default Wrapper;
